import _str from "shared/util/_str";

export const FOOTER_SECTIONS = {
	COMPANY: "COMPANY",
	CONDITIONS: "CONDITIONS",
	CONTACT: "CONTACT",
	FOLLOW: "FOLLOW",
	SPECIAL: "SPECIAL",
};

export const FOOTER_SECTION_ORDER = [
	FOOTER_SECTIONS.COMPANY,
	FOOTER_SECTIONS.CONDITIONS,
	FOOTER_SECTIONS.CONTACT,
	FOOTER_SECTIONS.FOLLOW,
	FOOTER_SECTIONS.SPECIAL,
];

export const FOOTER_SECTION_LABELS = {
	[FOOTER_SECTIONS.COMPANY]: _str("Company"),
	[FOOTER_SECTIONS.CONDITIONS]: _str("Conditions"),
	[FOOTER_SECTIONS.CONTACT]: _str("Contact"),
	[FOOTER_SECTIONS.FOLLOW]: _str("Follow"),
	[FOOTER_SECTIONS.SPECIAL]: _str("Special"),
};

export const FOOTER_SECTION_LINKS = {
	[FOOTER_SECTIONS.COMPANY]: [
		{
			label: _str("About"),
			path: "/about",
		},
		{
			label: _str("Careers"),
			path: "/careers",
		},
		{
			label: _str("Press"),
			path: "/press",
		},
		{
			label: _str("Ad Choices"),
			path: "/legal/privacy#third-parties",
		},
	],

	[FOOTER_SECTIONS.CONDITIONS]: [
		{
			label: _str("Privacy"),
			path: "/legal/privacy",
		},
		{
			label: _str("Cookies"),
			path: "/legal/cookies",
		},
		{
			label: _str("Terms"),
			path: "/legal/terms",
		},
		{
			label: _str("Community Guidelines"),
			path: "https://help.okcupid.com/article/142-community-guidelines",
			noSpa: true,
		},
	],

	[FOOTER_SECTIONS.CONTACT]: [
		{
			label: _str("Support"),
			path: "https://help.okcupid.com/",
			noSpa: true,
		},
		{
			label: _str("Security"),
			path: "/security",
		},
		{
			label: _str("Safety Tips"),
			path: "/legal/safety-tips",
		},
	],

	[FOOTER_SECTIONS.FOLLOW]: [
		{
			label: _str("Blog"),
			path: "https://theblog.okcupid.com/",
			noSpa: true,
		},
		{
			label: _str("Tech Blog"),
			path: "https://tech.okcupid.com/",
			noSpa: true,
		},
		{
			label: _str("Facebook"),
			path: "https://facebook.com/okcupid",
			noSpa: true,
		},
		{
			label: _str("Instagram"),
			path: "https://instagram.com/okcupid",
			noSpa: true,
		},
		{
			label: _str("Twitter"),
			path: "https://twitter.com/okcupid",
			noSpa: true,
		},
	],

	[FOOTER_SECTIONS.SPECIAL]: [
		{
			label: _str("Download Apps"),
			path: "/mobile",
			noSpa: true,
		},
	],
};



// WEBPACK FOOTER //
// ./src/shared/components/Footer/constants.js